import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const slides = [
  { src: "/assets/img/kfg22.png", alt: "logo_banner" },
  { src: "/assets/img/kh1.jpeg", alt: "kh1" },
  { src: "/assets/img/kh2.jpeg", alt: "kh2" },
  { src: "/assets/img/kh3.jpeg", alt: "kh3" },
  // { src: "/assets/img/2.jpeg", alt: "house_campaign_banner" },
  // { src: "/assets/img/3.jpeg", alt: "edu_campaign_banner" },
  // { src: "/assets/img/4.jpeg", alt: "banner4" },
  { src: "/assets/img/5.jpeg", alt: "banner5" },
  { src: "/assets/img/7.jpeg", alt: "banner7" },
];

export default function HeroSlider() {
  return (
    <section className="px-0 mt-4">
      <div className="relative w-full overflow-hidden">
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{
            clickable: true,
            el: ".custom-pagination",
          }}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          loop
          className="w-full"
        >
          {slides.map((s, i) => (
            <SwiperSlide key={i}>
              <div className="flex justify-center items-center w-full">
                <img
                  src={s.src}
                  alt={s.alt}
                  className="
                    w-[98%]               /* marge à gauche/droite */
                    h-auto
                    max-h-[220px]         /* hauteur mobile */
                    sm:max-h-[300px]
                    md:max-h-[420px]
                    lg:max-h-[550px]
                    rounded-3xl           
                    object-contain        
                    bg-white
                    shadow-md
                    transition-all duration-500
                  "
                  draggable="false"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="custom-pagination text-center mt-2"></div>
      </div>
    </section>
  );
}
